import request from '@/utils/request'

//数据字典列表
export function getDicListByPage(data, log) {
  return request({
    url: `/sys/dictionary`,
    params: data,
    log,
    method: 'get'
  })
}

//新增数据字典
export function addDic(data, log){
  return request({
    url: `/sys/dictionary`,
    method: 'post',
    log,
    data
  })
}

//编辑数据字典
export function editDic(data, log){
  return request({
    url: `/sys/dictionary`,
    method: 'put',
    log,
    data
  })
}

//删除数据字典
export function deleteDic(ids, log) {
  return request({
    url: `/sys/dictionary/delete/${ids}`,
    method: 'delete',
    log
  })
}

//数据字典详情
export function getDicDetailListByPage(data, log) {
  return request({
    url: `/sys/dictype/page`,
    params: data,
    method: 'get',
    log
  })
}

//新增类型
export function addDicType(data, log){
  return request({
    url: `/sys/dictype`,
    method: 'post',
    log,
    data
  })
}

//编辑类型
export function editDicType(data, log){
  return request({
    url: `/sys/dictype`,
    method: 'put',
    log,
    data
  })
}

//删除类型
export function deleteDicType(ids, log) {
  return request({
    url: `/sys/dictype/delete/${ids}`,
    method: 'delete',
    log
  })
}

//字典类型列表
export function getDicTypeList(data,log) {
  return request({
    url: `/sys/dictype/list`,
    params: data,
    method: 'get',
    log
  })
}

